import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';
import { CcResolution, CcSubjectKind, OpenResolutionPayload } from './credit-committee.types';

@Injectable({ providedIn: 'root' })
export class CreditCommitteeService {
  private readonly http = inject(HttpClient);
  private readonly base = `${environment.apiUrl}/api/cc-resolutions`;

  /** List resolutions, optionally scoped to a subject. */
  list(params?: { subject_kind?: CcSubjectKind; subject_id?: string }): Observable<CcResolution[]> {
    let httpParams = new HttpParams();
    if (params?.subject_kind) httpParams = httpParams.set('subject_kind', params.subject_kind);
    if (params?.subject_id) httpParams = httpParams.set('subject_id', params.subject_id);
    return this.http.get<CcResolution[]>(`${this.base}/`, { params: httpParams });
  }

  open(payload: OpenResolutionPayload): Observable<CcResolution> {
    return this.http.post<CcResolution>(`${this.base}/`, payload);
  }

  /** Cast the current user's approval on a resolution. */
  approve(shortId: string, note = ''): Observable<CcResolution> {
    return this.http.post<CcResolution>(`${this.base}/${shortId}/approvals/`, { note });
  }

  /** Withdraw an OPEN resolution — a member's act, with its written reason (FLOW-405). */
  withdraw(shortId: string, reason: string): Observable<CcResolution> {
    return this.http.post<CcResolution>(`${this.base}/${shortId}/withdraw/`, { reason });
  }
}
